import config from './config';

async function sleep(ms) {
	return new Promise(resolve => setTimeout(resolve, ms));
}

function validate_name(name) {
	// Check if name is not empty and does not consist only of whitespace
	if (!name || name.trim() === '') {
		return false;
	}
	
	// Check length (example: minimum 1 character, maximum 50 characters)
	if (name.length < 1 || name.length > 50) {
		return false;
	}

	// Allow letters (including Swedish åäöÅÄÖ), numbers, spaces, hyphens, underscores, apostrophes, and common punctuation
	const allowedCharacters = /^[a-zA-ZåäöÅÄÖ0-9\s\-_'.,!?]+$/;
	if (!allowedCharacters.test(name)) {
		return false;
	}

	return true;
}

const generate_qr_code = (scan_token) => {
	return config.TUUTUUM_QR_SITE + '/?token=' + scan_token;
};

const validate_phone_number = (value) => {
	// Convert the input to a string to handle different data types
	const str = String(value);
	// Use a regular expression to test if the string contains only digits
	return /^\d+$/.test(str);
};


export {
	sleep,
	validate_name,
	validate_phone_number,
	generate_qr_code
};
